import { Proxify } from '@epihub/core/src/instrument/proxify';
import { useTheme as useEmotionTheme, css as emotionCSS } from '@emotion/react';
import { type initializeTheme, type createEmotionFunctions } from '@epihub/web/src/theme';
import { __expectDeps, expectWebDeps } from '@epihub/web/src/_ctx/deps';

export const styled: ReturnType<typeof createEmotionFunctions>['styled'] = Proxify({
  get<X>({ prop }) {
    return expectWebDeps().emotion[prop];
  },
  apply<X>({ args }) {
    // @ts-expect-error
    return expectWebDeps().emotion(...args);
  },
});

export const css: ReturnType<typeof initializeTheme>['emotion']['css'] = Proxify({
  get<X>({ prop }) {
    __expectDeps();
    return emotionCSS[prop];
  },
  apply<X>({ args }) {
    __expectDeps();
    return emotionCSS(...args);
  },
});

export const useTheme = (
  () => {
    __expectDeps();
    return useEmotionTheme();
  }
) as ReturnType<typeof initializeTheme>['emotion']['useTheme'];
